import { useEffect, useRef, useState } from "react";
import type { CSSProperties, ComponentPropsWithoutRef } from "react";
import { createPortal } from "react-dom";
import { BLOCK_ACTIONS_Z_INDEX } from "./constants";
import { useCanvasToolsPositions } from "./useCanvasToolsPositions";

export interface CanvasToolsBlockActionsProps
  extends ComponentPropsWithoutRef<"div"> {}

const TOP_OFFSET = -38; // Match with hover spacing

export const CanvasToolsBlockActions = ({
  children,
}: CanvasToolsBlockActionsProps) => {
  const [position, setPosition] = useState<CSSProperties>({});
  const actionsRef = useRef<HTMLDivElement>(null);

  const { selectedBlock, positions } = useCanvasToolsPositions();

  useEffect(() => {
    if (!positions) {
      return;
    }

    const actionsWidth = actionsRef.current?.offsetWidth || 0;

    setPosition({
      position: "absolute",
      top: positions.elementRect.top + TOP_OFFSET,
      left: positions.elementRect.right - actionsWidth,
      zIndex: BLOCK_ACTIONS_Z_INDEX,
      pointerEvents: "auto",
    });
  }, [positions]);

  if (!selectedBlock) {
    return null;
  }

  const blockActionsElement = (
    <div
      ref={actionsRef}
      className="bg-circle pointer-events-auto flex items-center gap-0.5 rounded p-1"
      style={position}
    >
      {children}
    </div>
  );

  // Find the CanvasCard container to portal to (this has the right coordinate system)
  const canvasCard = document.getElementById("builder-ui-canvas-card");
  if (!canvasCard) {
    return blockActionsElement;
  }

  return createPortal(blockActionsElement, canvasCard);
};
